export function SwapArrow({ onClick }: { onClick: () => void }) {
  return (
    <div className="relative z-10 my-[-13px] flex justify-center">
      <button
        onClick={onClick}
        className="flex h-8 w-8 items-center justify-center rounded-[var(--radius-sm)] border border-[var(--color-border-card-section)] bg-[var(--color-bg-page)] text-[var(--color-text-tertiary)] transition-colors hover:text-[var(--color-text-secondary)]"
        aria-label="Swap direction"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 384 512"
          fill="currentColor"
        >
          <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
        </svg>
      </button>
    </div>
  );
}
